import axios from 'axios';
import ENDPOINTS from 'constants/endpoints.constants';
import APIError from 'exceptions/APIError';
import Shipment from 'interfaces/PmParcel';

export const postValidateConsumer = async (
  orgId: number,
  slug: string,
  shipmentPk: number,
  searchTerms: { [key: string]: string | number },
): Promise<{ data: { token: string; shipment: Shipment } }> => {
  try {
    const url = `${ENDPOINTS.TRACKING_ANTENNA_HOST}/api/v1/ptp/shipments/${orgId}/validate/`;
    const { data } = await axios.post(url, {
      slug,
      shipment_pk: shipmentPk,
      search_terms: searchTerms,
    });

    return data;
  } catch (error) {
    if (error.response) {
      throw new APIError(error.response?.data?.message);
    }

    throw error;
  }
};
